import React from 'react';
import { Util } from '../../common/index'
import TotalShow from '../../common/TotalShow';

type DataT = {
  title?: string
  img?: string
}

interface Iprops {
  data?: Array<DataT>
  pClassName?: string
  location?: string
  hasMore?: boolean
  isShowTotal?: boolean
}

function OtherList(props: Iprops) {
  const {
    pClassName,
    data,
    location,
    hasMore,
    isShowTotal,
  } = props
  let unik = new Date().valueOf()
  return (
    <div className={`mt-[8px] ${pClassName}`}>
      {/* {
        data && data.length && isShowTotal ? <TotalShow 
          total={hasMore ? `${data.length}+` : data.length}
          lastTitle=' houses on other platforms'
        /> : ''
      } */}
      {
        data?.map((item, ind) => {
          return (
            <Util
              isOwen={false}
              key={`${ind + unik}`}
              data={item}
              location={location}
            />
          )
        })
      }
    </div>
  );
}

export default OtherList;
